<template>
  <div class="modal-overlay">
    <div class="mmodal-content" style="max-width: 90vw">
      <div class="modal-header">
        <h5 class="modal-title">Enter Lab Result</h5>
        <button type="button" class="close" @click="closeModal">&times;</button>
      </div>

      <div v-if="loading" class="modal-body">
        <loader />
      </div>

      <div v-if="!loading" class="modal-body">
        <!-- Patient summary -->
        <div class="profile-header">
          <!-- <div>
            <h2>{{ patient.name }}</h2>
            <p>Patient ID: {{ patient.id }}</p>
            <p>Visit ID: {{ visit_id }}</p>
          </div> -->

          <patient_biodata
            :patient_id="patient_identity"
            :visit_id="visit_id"
          />
        </div>

        <!-- Lab result inputs -->
        <div class="form-section">
          <!-- Notes -->
          <div class="form-group">
            <label>Test Results Notes</label>
            <textarea
              v-model="form.notes"
              class="form-control"
              rows="3"
            ></textarea>
          </div>

          <!-- Test Status -->
          <div class="form-group">
            <label>Status</label>
            <select v-model="form.status" class="form-control">
              <option value="not_applicable">Not Applicable</option>
              <option value="negative">Negative</option>
              <option value="positive">Positive</option>
            </select>
          </div>

          <!-- Optional File Upload -->
          <div class="form-group">
            <label>Attach File (optional)</label>
            <input
              type="file"
              @change="handleFileUpload"
              class="form-control"
            />
          </div>

          <!-- Tabular Data -->
          <div class="form-group">
            <label>Detailed Results</label>
            <table class="result-table">
              <thead>
                <tr>
                  <th>Parameter</th>
                  <th>Value</th>
                  <th>Unit</th>
                  <th>Reference Range</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in form.tableData" :key="index">
                  <!-- Parameter with autocomplete -->
                  <td>
                    <input
                      v-model="row.parameter"
                      list="parameter-suggestions"
                      class="form-control"
                      @change="autoFillDetails(row)"
                    />
                  </td>

                  <!-- Value -->
                  <td>
                    <input v-model="row.value" class="form-control" />
                  </td>

                  <!-- Unit -->
                  <td>
                    <input v-model="row.unit" class="form-control" />
                  </td>

                  <!-- Reference Range -->
                  <td>
                    <input v-model="row.referenceRange" class="form-control" />
                  </td>

                  <!-- Remove row -->
                  <td>
                    <button
                      type="button"
                      class="btn btn-danger btn-sm"
                      @click="removeRow(index)"
                    >
                      x
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>

            <!-- Suggestions list -->
            <datalist id="parameter-suggestions">
              <option
                v-for="(info, name) in parameterLibrary"
                :key="name"
                :value="name"
              >
                {{ name }}
              </option>
            </datalist>

            <button
              type="button"
              class="btn btn-primary btn-sm mt-2"
              @click="addRow"
            >
              + Add Row
            </button>
          </div>
        </div>
      </div>

      <div v-if="!loading" class="modal-footer">
        <button type="button" class="btn btn-secondary" @click="closeModal">
          Cancel
        </button>
        <button type="button" class="btn btn-primary" @click="submitForm">
          Save
        </button>
      </div>
    </div>
  </div>
  <ConsumablesModal
    :conducted_record="service_record"
    v-if="showConsumablesModal"
    @hide-consumables-model="hideConMod"
    @consumables-submitted="handleConsumablesSubmitted"
  />
</template>

<script>
import ConsumablesModal from "./ConsumablesModal.vue";
import { generalApiUploadRequest } from "../../../api/apiIndex";
import { generalApiRequest } from "../../../api/apiIndex";
import patient_biodata from "../../Patients/components/patient_biodata.vue";
import lab_parameter_library from "./lab_parameter_library";
import loader from "../../special_clinics/dialysis/loader.vue";
export default {
  name: "LabResultModal",
  data() {
    return {
      loading: false,
      patient: {},
      service_record: {},
      // visit_id: "",
      parameterLibrary: lab_parameter_library,
      showConsumablesModal: false,
      // Form data
      form: {
        notes: "",
        status: "not_applicable",
        file: null,
        tableData: [],
      },
    };
  },
  props: {
    test_id: {
      type: [String, Number],
      required: true,
    },
    patient_identity: {
      type: [String, Number],
      required: true,
    },
    visit_id: {
      type: [String, Number],
      required: true,
    },
  },
  components: {
    patient_biodata,
    ConsumablesModal,
    loader,
  },
  methods: {
    hideConMod() {
      this.showConsumablesModal = false;
      this.closeModal();
    },
    async get_test_data_for_update() {
      try {
        this.loading = true;
        const url = "get_test_result_for_update/" + this.test_id;
        const res = await generalApiRequest(url, "GET", {}, 1);
        console.log(res);

        (this.form.notes = res.test.note),
          (this.form.status = res.test.result),
          res.tabular.forEach((element) => {
            this.form.tableData.push({
              parameter: element.parameter,
              value: element.result,
              unit: element.unit,
              referenceRange: element.reference_range,
            });
          });
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    async submitForm(e) {
      e.preventDefault();
      this.loading = true;
      const formData = new FormData();
      formData.append("service_id", this.test_id);
      formData.append("result", this.form.status);
      // formData.append("table_data", this.form.tableData);

      formData.append("table_data", JSON.stringify(this.form.tableData));

      formData.append("note", this.form.notes);
      if (this.file) {
        formData.append("file", this.form.file);
      }

      // try {
      // Use await to get the result of the API call
      const res = await generalApiUploadRequest(
        "clinical-results",
        formData,
        1,
      );

      // Chain .then() to handle a successful response
      Promise.resolve(res)
        .then((result) => {
          // console.log("Submitted Lab Result:", result);
          if (typeof result.data === "object" && result.data !== null) {
            this.service_record = result.data;
            this.showConsumablesModal = true;
          } else {
            console.log(
              "❌ result.data is not an object. Shouldnt display consumable modal",
            );
            this.closeModal();
          }
        })
        // Chain .catch() to handle any errors that occurred in the promise chain
        .catch((error) => {
          console.error("Error submitting result:", error);
        })
        // Chain .finally() for code that must run regardless of success or failure
        .finally(() => {
          console.log("Lab results submission process complete.");
          // window.location.reload();
          // this.closeModal();
        });
      // } catch (error) {
      //   // This catch block handles errors from the initial `await` call itself
      //   console.error("An error occurred during the API request:", error);
      // }
      this.loading = false;
    },
    closeModal() {
      this.$emit("close-lab-results-modal2");
    },
    saveModal() {
      const payload = {
        patient_id: this.patient.id,
        visit_id: this.visit_id,
        notes: this.form.notes,
        status: this.form.status,
        file: this.form.file,
        tableData: this.form.tableData,
      };
      console.log("Saving payload:", payload);
      this.$emit("save", payload);
    },
    handleFileUpload(event) {
      this.form.file = event.target.files[0];
    },
    addRow() {
      this.form.tableData.push({
        parameter: "",
        value: "",
        unit: "",
        referenceRange: "",
      });
    },
    removeRow(index) {
      this.form.tableData.splice(index, 1);
    },

    autoFillDetails(row) {
      if (this.parameterLibrary[row.parameter]) {
        row.unit = this.parameterLibrary[row.parameter].unit;
        row.referenceRange = this.parameterLibrary[
          row.parameter
        ].referenceRange;
      } else {
        row.unit = "";
        row.referenceRange = "";
      }
    },
  },
  mounted() {
    this.get_test_data_for_update();
  },
};
</script>

<style scoped>
.modal-body {
  padding: 1rem;
  overflow-y: auto;
  flex-grow: 1;
}

.modal-footer {
  border-top: 1px solid #ddd;
  display: flex;
  justify-content: flex-end;
}

.form-group {
  margin-bottom: 1rem;
}

.result-table {
  width: 100%;
  border-collapse: collapse;
}

.result-table th,
.result-table td {
  border: 1px solid #ddd;
  padding: 0.5rem;
}

.close {
  background: rgb(233, 22, 22);
  border: 1px solid rgb(182, 178, 178);
  font-size: 1.5rem;
  color: white;
  line-height: 1;
  cursor: pointer;
}
</style>
